import styled from 'styled-components'

interface TooltipButtonUiStylesInterface {
  size: string
  isVisible?: boolean
  bgColor: string
  bgColorActive: string
}

export const TooltipButtonUi = styled.button<TooltipButtonUiStylesInterface>`
  color: ${p => (p.isVisible ? p.bgColorActive : p.bgColor)}; 
  margin-left: 5px;
  transition: color .1s ease;
  height: ${p => p.size};
  width: ${p => p.size};
  border-radius: 50%;
  display: flex;
  padding: 0;
  cursor: pointer;
  border: none;
  transition: color 0.25s ease-in-out;
  &:hover {
    color: ${p => p.bgColorActive};
  }
`
